interface GooglePlaceComponent {
  long_name: string
  short_name: string
  types: string[]
}

export interface GooglePlace {
  address_components?: GooglePlaceComponent[]
}

enum EAddressType {
  Country = 'country',
  State = 'administrative_area_level_1',
  City = 'locality',
}

export interface ExtractedLocationParts {
  countryLong: string
  countryShort: string
  stateLong: string
  stateShort: string
  cityLong: string
  cityShort: string
}

export const extractLocationParts = (
  place: GooglePlace,
): ExtractedLocationParts => {
  const components = place?.address_components
  const findPart = (type: EAddressType) =>
    components?.find((c) => c.types.includes(type))

  const country = findPart(EAddressType.Country)
  const state = findPart(EAddressType.State)
  const city = findPart(EAddressType.City)

  return {
    countryLong: country?.long_name ?? '',
    countryShort: country?.short_name ?? '',
    stateLong: state?.long_name ?? '',
    stateShort: state?.short_name ?? '',
    cityLong: city?.long_name ?? '',
    cityShort: city?.short_name ?? '',
  }
}
